import { render, staticRenderFns } from "./SectionDisclaimer.vue?vue&type=template&id=75deadba&scoped=true&"
import script from "./SectionDisclaimer.vue?vue&type=script&lang=js&"
export * from "./SectionDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./SectionDisclaimer.vue?vue&type=style&index=0&id=75deadba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75deadba",
  null
  
)

export default component.exports